"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddDeviceModal = AddDeviceModal;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("react");
var devices_1 = require("../../../constants/devices");
var pagination_1 = require("../../../constants/pagination");
var area_1 = require("../../../features/apis/area");
var device_1 = require("../../../features/apis/device");
var facility_1 = require("../../../features/apis/facility");
var api_error_message_1 = require("../../../utils/api-error-message");
var merge_by_id_1 = require("../../../utils/merge-by-id");
var paginated_content_1 = require("../../../utils/paginated-content");
var permission_error_1 = require("../../../utils/permission-error");
var use_debounce_1 = require("../../../utils/use-debounce");
var button_component_1 = require("../../ui/button-component");
var text_component_1 = require("../../ui/text-component");
var device_form_fields_1 = require("./device-form-fields");
var ewelink_device_picker_1 = require("./ewelink-device-picker");
function AddDeviceModal(props) {
    var _this = this;
    var _a, _b, _c, _d, _e, _f;
    var FACILITY_PAGE_SIZE = 30;
    var AREA_PAGE_SIZE = 30;
    var isOpen = props.isOpen, clientId = props.clientId, userId = props.userId, onClose = props.onClose, onCreated = props.onCreated;
    var _g = (0, react_2.useState)(""), name = _g[0], setName = _g[1];
    var _h = (0, react_2.useState)(""), deviceIccid = _h[0], setDeviceIccid = _h[1];
    var _j = (0, react_2.useState)(""), deviceFamily = _j[0], setDeviceFamily = _j[1];
    var _k = (0, react_2.useState)(""), deviceType = _k[0], setDeviceType = _k[1];
    var _l = (0, react_2.useState)(true), alarms = _l[0], setAlarms = _l[1];
    var _m = (0, react_2.useState)(""), error = _m[0], setError = _m[1];
    var _o = (0, react_2.useState)(""), facilityId = _o[0], setFacilityId = _o[1];
    var _p = (0, react_2.useState)(""), facilitySearch = _p[0], setFacilitySearch = _p[1];
    var _q = (0, react_2.useState)(pagination_1.DEFAULT_PAGE_NUMBER), facilityPage = _q[0], setFacilityPage = _q[1];
    var _r = (0, react_2.useState)([]), facilities = _r[0], setFacilities = _r[1];
    var debouncedFacilitySearch = (0, use_debounce_1.useDebouncedValue)(facilitySearch);
    var _s = (0, react_2.useState)(""), areaId = _s[0], setAreaId = _s[1];
    var _t = (0, react_2.useState)(""), areaSearch = _t[0], setAreaSearch = _t[1];
    var _u = (0, react_2.useState)(pagination_1.DEFAULT_PAGE_NUMBER), areaPage = _u[0], setAreaPage = _u[1];
    var _v = (0, react_2.useState)([]), areas = _v[0], setAreas = _v[1];
    var debouncedAreaSearch = (0, use_debounce_1.useDebouncedValue)(areaSearch);
    var _w = (0, device_1.useCreateDeviceMutation)(), createDevice = _w[0], isCreating = _w[1].isLoading;
    var requestTokenRef = (0, react_2.useRef)(0);
    // A synchronous lock also catches a second click before React renders the mutation's loading state.
    var requestInFlightRef = (0, react_2.useRef)(false);
    (0, react_2.useEffect)(function () { return function () {
        requestTokenRef.current += 1;
    }; }, []);
    var _x = (0, facility_1.useGetFacilitiesQuery)({ clientId: clientId, userId: userId !== null && userId !== void 0 ? userId : "", size: FACILITY_PAGE_SIZE, pageNumber: facilityPage, search: debouncedFacilitySearch || undefined }, { skip: !isOpen || !clientId || !userId }), facilitiesData = _x.currentData, isLoadingFacilities = _x.isLoading, isFetchingFacilities = _x.isFetching, isFacilitiesError = _x.isError, facilitiesError = _x.error, refetchFacilities = _x.refetch;
    var _y = (0, area_1.useGetAreasQuery)({ clientId: clientId, facilityId: facilityId, size: AREA_PAGE_SIZE, pageNumber: areaPage, search: debouncedAreaSearch || undefined }, { skip: !isOpen || !clientId || !facilityId }), areasData = _y.currentData, isLoadingAreas = _y.isLoading, isFetchingAreas = _y.isFetching, isAreasError = _y.isError, areasError = _y.error, refetchAreas = _y.refetch;
    var canLoadMoreFacilities = (_c = (_b = (_a = facilitiesData === null || facilitiesData === void 0 ? void 0 : facilitiesData.content) === null || _a === void 0 ? void 0 : _a.pagination) === null || _b === void 0 ? void 0 : _b.hasNextPage) !== null && _c !== void 0 ? _c : false;
    var canLoadMoreAreas = (_f = (_e = (_d = areasData === null || areasData === void 0 ? void 0 : areasData.content) === null || _d === void 0 ? void 0 : _d.pagination) === null || _e === void 0 ? void 0 : _e.hasNextPage) !== null && _f !== void 0 ? _f : false;
    // The API doesn't filter areas by facility server-side yet, so this narrows the fetched page client-side; harmless once it does.
    var areasForFacility = areas.filter(function (area) { var _a; return ((_a = area.facility) === null || _a === void 0 ? void 0 : _a.id) === facilityId; });
    var deviceTypeOptions = deviceFamily ? devices_1.DEVICE_TYPES_BY_FAMILY[deviceFamily] : [];
    (0, react_2.useEffect)(function () {
        setFacilityPage(pagination_1.DEFAULT_PAGE_NUMBER);
    }, [debouncedFacilitySearch, clientId]);
    (0, react_2.useEffect)(function () {
        setAreaPage(pagination_1.DEFAULT_PAGE_NUMBER);
        setAreas([]);
    }, [debouncedAreaSearch, clientId, facilityId]);
    (0, react_2.useEffect)(function () {
        var incomingFacilities = (0, paginated_content_1.getContentItems)(facilitiesData);
        if (facilityPage === pagination_1.DEFAULT_PAGE_NUMBER) {
            setFacilities(incomingFacilities);
            return;
        }
        setFacilities(function (currentFacilities) { return (0, merge_by_id_1.mergeById)(currentFacilities, incomingFacilities); });
    }, [facilitiesData, facilityPage]);
    (0, react_2.useEffect)(function () {
        var incomingAreas = (0, paginated_content_1.getContentItems)(areasData);
        if (areaPage === pagination_1.DEFAULT_PAGE_NUMBER) {
            setAreas(incomingAreas);
            return;
        }
        setAreas(function (currentAreas) { return (0, merge_by_id_1.mergeById)(currentAreas, incomingAreas); });
    }, [areasData, areaPage]);
    (0, react_2.useEffect)(function () {
        if (!facilityId) {
            return;
        }
        var isFacilityStillAvailable = facilities.some(function (facility) { return facility.id === facilityId; });
        if (!isFacilityStillAvailable) {
            setFacilityId("");
        }
    }, [facilities, facilityId]);
    (0, react_2.useEffect)(function () {
        setAreaId("");
    }, [facilityId]);
    var isSonoff = deviceFamily === "SONOFF";
    var wasSonoffRef = (0, react_2.useRef)(isSonoff);
    (0, react_2.useEffect)(function () {
        setDeviceType("");
        // A Sonoff ID comes from the eWeLink picker, so it only makes sense for Sonoff; a typed ICCID is kept
        // when switching between the other families.
        if (wasSonoffRef.current !== isSonoff) {
            setDeviceIccid("");
        }
        wasSonoffRef.current = isSonoff;
    }, [deviceFamily]);
    var loadMoreFacilities = function () {
        if (!canLoadMoreFacilities || isFetchingFacilities) {
            return;
        }
        setFacilityPage(function (currentPage) { return currentPage + 1; });
    };
    var loadMoreAreas = function () {
        if (!canLoadMoreAreas || isFetchingAreas) {
            return;
        }
        setAreaPage(function (currentPage) { return currentPage + 1; });
    };
    var isFormComplete = !!name.trim() && !!deviceIccid.trim() && !!deviceFamily && !!facilityId && !!areaId && (deviceTypeOptions.length === 0 || !!deviceType);
    var resetForm = function () {
        setName("");
        setDeviceIccid("");
        setDeviceFamily("");
        setDeviceType("");
        setAlarms(true);
        setFacilityId("");
        setFacilitySearch("");
        setFacilityPage(pagination_1.DEFAULT_PAGE_NUMBER);
        setFacilities([]);
        setAreaId("");
        setAreaSearch("");
        setAreaPage(pagination_1.DEFAULT_PAGE_NUMBER);
        setAreas([]);
        setError("");
    };
    var handleClose = function () {
        if (requestInFlightRef.current || isCreating) {
            return;
        }
        requestTokenRef.current += 1;
        resetForm();
        onClose();
    };
    var handleCreate = function () { return __awaiter(_this, void 0, void 0, function () {
        var requestToken, response, createError_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (requestInFlightRef.current || isCreating) {
                        return [2 /*return*/];
                    }
                    setError("");
                    if (!clientId) {
                        setError("Please select an active client before adding a device.");
                        return [2 /*return*/];
                    }
                    if (!isFormComplete) {
                        setError("Please complete all fields.");
                        return [2 /*return*/];
                    }
                    requestToken = requestTokenRef.current;
                    requestInFlightRef.current = true;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, createDevice({
                            client_id: clientId,
                            DeviceICCID: deviceIccid.trim(),
                            name: name.trim(),
                            deviceFamily: deviceFamily,
                            deviceType: deviceType || undefined,
                            facilityId: facilityId,
                            areaId: areaId,
                            alarms: alarms,
                        }).unwrap()];
                case 2:
                    response = _a.sent();
                    if (requestToken !== requestTokenRef.current) {
                        return [2 /*return*/];
                    }
                    if (!response.success) {
                        setError(response.message || "Unable to create device. Please try again.");
                        return [2 /*return*/];
                    }
                    onCreated === null || onCreated === void 0 ? void 0 : onCreated();
                    requestInFlightRef.current = false;
                    handleClose();
                    return [2 /*return*/];
                case 3:
                    createError_1 = _a.sent();
                    if (requestToken !== requestTokenRef.current) {
                        return [2 /*return*/];
                    }
                    setError((0, api_error_message_1.getApiErrorMessage)(createError_1, "Unable to create device. Please try again."));
                    return [3 /*break*/, 5];
                case 4:
                    requestInFlightRef.current = false;
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsx)(react_1.Modal, { isOpen: isOpen, onOpenChange: function (open) {
            if (!open)
                handleClose();
        }, children: (0, jsx_runtime_1.jsx)(react_1.Modal.Backdrop, { isDismissable: !isCreating, isKeyboardDismissDisabled: isCreating, children: (0, jsx_runtime_1.jsx)(react_1.Modal.Container, { children: (0, jsx_runtime_1.jsxs)(react_1.Modal.Dialog, { className: "sm:max-w-[560px]", children: [(0, jsx_runtime_1.jsx)(react_1.Modal.CloseTrigger, { isDisabled: isCreating, onPress: handleClose }), (0, jsx_runtime_1.jsx)(react_1.Modal.Header, { children: (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-1", children: [(0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "large", weight: "bold", color: "dark-gray-1", label: "Add Device" }), (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "small", color: "medium-gray", label: "Register a new device by filling out the details below." })] }) }), (0, jsx_runtime_1.jsxs)(react_1.Modal.Body, { className: "p-1", children: [(0, jsx_runtime_1.jsx)("div", { className: "grid grid-cols-1 sm:grid-cols-2 gap-3", children: (0, jsx_runtime_1.jsx)(device_form_fields_1.DeviceFormFields, { name: name, onNameChange: setName, deviceIccid: deviceIccid, onDeviceIccidChange: setDeviceIccid, deviceIccidField: isSonoff ? ((0, jsx_runtime_1.jsx)(ewelink_device_picker_1.EwelinkDevicePicker, { isOpen: isOpen, clientId: clientId, userId: userId, selectedId: deviceIccid, onSelect: function (device) {
                                                setDeviceIccid(device.id);
                                                setDeviceType(device.type);
                                                setName(function (currentName) { return currentName || device.name; });
                                            } })) : undefined, deviceFamily: deviceFamily, onDeviceFamilyChange: setDeviceFamily, deviceType: deviceType, onDeviceTypeChange: setDeviceType, deviceTypeOptions: deviceTypeOptions, isDeviceTypeDisabled: isSonoff, alarms: alarms, onAlarmsChange: setAlarms, facilityId: facilityId, onFacilityIdChange: setFacilityId, facilitySearch: facilitySearch, onFacilitySearchChange: setFacilitySearch, facilities: facilities, isLoadingFacilities: isLoadingFacilities, isLoadingMoreFacilities: isFetchingFacilities && !isLoadingFacilities, canLoadMoreFacilities: canLoadMoreFacilities, onLoadMoreFacilities: loadMoreFacilities, areaId: areaId, onAreaIdChange: setAreaId, areaSearch: areaSearch, onAreaSearchChange: setAreaSearch, areas: areasForFacility, isLoadingAreas: isLoadingAreas, isLoadingMoreAreas: isFetchingAreas && !isLoadingAreas, canLoadMoreAreas: canLoadMoreAreas, onLoadMoreAreas: loadMoreAreas }) }), isFacilitiesError && ((0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-2", children: [(0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "xsmall", color: "red-600", label: (0, permission_error_1.getLoadErrorMessage)(facilitiesError, "Unable to load facilities.") }), !(0, permission_error_1.isPermissionDeniedError)(facilitiesError) && ((0, jsx_runtime_1.jsx)(button_component_1.ButtonComponent, { label: "Retry", variant: "ghost", textSize: "xsmall", onPress: function () { return refetchFacilities(); } }))] })), isAreasError && ((0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-2", children: [(0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "xsmall", color: "red-600", label: (0, permission_error_1.getLoadErrorMessage)(areasError, "Unable to load areas.") }), !(0, permission_error_1.isPermissionDeniedError)(areasError) && (0, jsx_runtime_1.jsx)(button_component_1.ButtonComponent, { label: "Retry", variant: "ghost", textSize: "xsmall", onPress: function () { return refetchAreas(); } })] })), error && ((0, jsx_runtime_1.jsx)("div", { role: "alert", children: (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "small", color: "red-600", label: error }) }))] }), (0, jsx_runtime_1.jsxs)(react_1.Modal.Footer, { children: [(0, jsx_runtime_1.jsx)(button_component_1.ButtonComponent, { label: "Cancel", variant: "secondary", onPress: handleClose, isDisabled: isCreating }), (0, jsx_runtime_1.jsx)(button_component_1.ButtonComponent, { label: "Create Device", onPress: handleCreate, isPending: isCreating, isDisabled: !clientId || !isFormComplete, color: "white", backgroundColor: "primary-navy", hoverColor: "primary-navy-light" })] })] }) }) }) }));
}
